import { translationsDashboard_sv_part1 } from "./translationsDashboard.sv.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationsDashboard_sv_part2 } from "./translationsDashboard.sv.part2";
import { translationsDashboard_sv_aiModelCalls } from "./translationsDashboard.sv.aiModelCalls";

export const translationsDashboard_sv = defineTranslationTree({
  ...translationsDashboard_sv_part1,
  ...translationsDashboard_sv_part2,
  ...translationsDashboard_sv_aiModelCalls,
});
